package com.kelimesoft.etutpro.models

enum class EtutRole(val image: String, val text: String) {
    Ogrenci(Images.Ogrenci, "Öğrenci"),
    Ogretmen(Images.Ogretmen, "Öğretmen"),
    Veli(Images.Veli, "Veli")
}